/* eslint-disable no-case-declarations  */
import { combineReducers } from 'redux';
import * as constants from './constants';
import { isSameProduct } from './selectors';
import { stringifyFrequency } from './api';

export const optedin = (state = [], action) => {
  switch (action.type) {
    case constants.OPTIN_PRODUCT:
    case constants.PRODUCT_CHANGE_FREQUENCY:
      const [[oldone], rest] = state.reduce(
        (acc, val) => acc[isSameProduct(action.payload.product, val) ? 0 : 1].push(val) && acc,
        [[], []]
      );
      return (rest || []).concat({
        ...oldone,
        ...action.payload.product,
        frequency: action.payload.frequency
      });
    case constants.OPTOUT_PRODUCT:
      return state.filter(a => !isSameProduct(action.payload.product, a));
    case constants.PRODUCT_HAS_CHANGED:
      return state.map(product =>
        isSameProduct(action.payload.product, product) ? { ...product, ...action.payload.newProduct } : product
      );
    case constants.CONVERT_ONE_TIME:
      return state.filter(a => !isSameProduct(action.payload.product, a));
    case constants.CHECKOUT:
      return [];
    default:
      return state;
  }
};

export const nextUpcomingOrder = (state = {}, { type, payload }) => {
  switch (type) {
    case constants.RECEIVE_ORDERS:
      return payload && payload.count > 0 ? { ...state, ...payload.results[0] } : state;
    case constants.CREATE_ONE_TIME:
      // when CREATE_IU_ORDER payload is just order item object created
      return { ...state, ...payload };
    default:
      return state;
  }
};

export const showUpsellModal = (state = false, action) => {
  switch (action.type) {
    case constants.PROMPT_UPSELL:
      return true;
    case constants.CONCLUDE_UPSELL:
      return false;
    default:
      return state;
  }
};

export const autoshipEligible = (state = {}, action) => {
  switch (action.type) {
    case constants.RECEIVE_OFFER:
      return {
        ...state,
        ...action.payload.autoship
      };
    default:
      return state;
  }
};

export const loading = (state = 0, action) => {
  // return false;
  switch (action.type) {
    case constants.REQUEST_AUTH:
    case constants.REQUEST_OFFER:
    case constants.REQUEST_ORDERS:
      return state + 1;
    case constants.RECEIVE_FETCH:
      return state - 1;
    default:
      return state;
  }
};

export const inStock = (state = {}, action) => {
  switch (action.type) {
    case constants.RECEIVE_OFFER:
      return {
        ...state,
        ...action.payload.in_stock
      };
    default:
      return state;
  }
};

export const frequency = (state = {}, action) => {
  switch (action.type) {
    case constants.OPTIN_PRODUCT:
    case constants.PRODUCT_CHANGE_FREQUENCY:
      return {
        ...state,
        [action.payload.product]: action.payload.frequency
      };
    case constants.OPTOUT_PRODUCT:
      return { ...state, [action.payload.product]: undefined };
    default:
      return state;
  }
};

export const auth = (state = false, action) => {
  switch (action.type) {
    case constants.AUTHORIZE:
      return {
        ...action.payload
      };
    case constants.UNAUTHORIZED:
      return false;
    default:
      return state;
  }
};

export const merchantId = (state = '', action) => {
  switch (action.type) {
    case constants.SET_MERCHANT_ID:
      return action.payload;
    default:
      return state;
  }
};

export const authUrl = (state = null, action) => {
  switch (action.type) {
    case constants.SET_AUTH_URL:
      return action.payload;
    default:
      return state;
  }
};

export const offer = (state = {}, action) => {
  switch (action.type) {
    case constants.RECEIVE_OFFER:
      return {
        ...state,
        ...action.payload.modifiers
      };
    default:
      return state;
  }
};
export const sessionId = (state = null, action) => {
  switch (action.type) {
    case constants.CREATED_SESSION_ID:
      return action.payload;
    default:
      return state;
  }
};

export const productOffer = (state = {}, action) => {
  switch (action.type) {
    case constants.RECEIVE_OFFER:
      return {
        ...state,
        ...Object.entries(action.payload.autoship)
          .map(([key]) => ({ [key]: Object.keys(action.payload.modifiers) }))
          .reduce((acc, object) => ({ ...acc, ...object }))
      };
    case constants.CHECKOUT:
      return {};
    default:
      return state;
  }
};

export const environment = (state = {}, action) => {
  switch (action.type) {
    case constants.SET_ENVIRONMENT_STAGING:
      return {
        ...state,
        name: 'staging',
        apiUrl: 'https://staging.om.ordergroove.com',
        // scUrl: 'https://staging.sc.ordergroove.com',
        // widgetsUrl: 'https://staging.static.ordergroove.com',
        // masterDbUrl: 'https://staging.v2.ordergroove.com',
        // reorderUrl: 'https://staging.static.ordergroove.com/reorder/',
        legoUrl: 'https://staging.restapi.ordergroove.com'
      };
    case constants.SET_ENVIRONMENT_DEV:
      return {
        ...state,
        name: 'dev',
        apiUrl: 'https://dev.om.ordergroove.com',
        // scUrl: 'https://dev.sc.ordergroove.com',
        // widgetsUrl: 'https://dev.static.ordergroove.com',
        // masterDbUrl: 'https://dev.api.ordergroove.com',
        // reorderUrl: 'https://staging.static.ordergroove.com/reorder/',
        legoUrl: 'https://dev.restapi.ordergroove.com'
      };
    case constants.SET_ENVIRONMENT_PROD:
      return {
        ...state,
        name: 'prod',
        apiUrl: 'https://om.ordergroove.com',
        // scUrl: 'https://sc.ordergroove.com',
        // widgetsUrl: 'https://static.ordergroove.com',
        // masterDbUrl: 'https://api.ordergroove.com',
        // reorderUrl: 'https://static.ordergroove.com/reorder/',
        legoUrl: 'https://restapi.ordergroove.com'
      };
    default:
      return state;
  }
};

export const locale = (
  state = {
    offerOptInLabel: 'Subscribe',
    offerOptOutLabel: 'Purchase one time',
    offerEveryLabel: 'Every',
    offerTooltipTrigger: 'Hover for additional info',
    offerTooltipContent: 'Seems this is a great subscription offering. Many fun details about this program exist.',
    optinButtonLabel: '•',
    optoutButtonLabel: '•',
    optinStatusOptedInLabel: "You're opted in!",
    optinStatusOptedOutLabel: "You're not opted in.",
    optinToggleLabel: '•',
    upsellButtonLabel: 'Add item to order on ',
    upsellButtonPrefix: '',
    upsellModalContent: 'Some upsell modal content',
    upsellModalOptInLabel: 'Subscribe',
    upsellModalOptOutLabel: 'Purchase one time',
    upsellModalTitle: 'Impulse Upsell',
    upsellModalConfirmLabel: 'Ok',
    upsellModalCancelLabel: 'Cancel',
    defaultFrequencyCopy: '(Recommended)',
    frequencyPeriods: {
      '1': 'day',
      '2': 'week',
      '3': 'month'
    }
  },
  action
) => {
  switch (action.type) {
    case constants.SET_LOCALE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export const config = (
  state = {
    frequencies: ['1_2', '2_2', '4_2'],
    defaultFrequency: '2_2',
    offerType: 'radio'
  },
  action
) => {
  switch (action.type) {
    case constants.SET_CONFIG:
      return {
        ...state,
        ...action.payload,
        defaultFrequency: action.payload.defaultFrequency
          ? stringifyFrequency(action.payload.defaultFrequency)
          : state.defaultFrequency,
        frequencies: action.payload.frequencies ? action.payload.frequencies.map(stringifyFrequency) : state.frequencies
      };
    default:
      return state;
  }
};

export const previewStandardOffer = (state = false, action) => {
  switch (action.type) {
    case constants.SET_PREVIEW_STANDARD_OFFER:
      return action.payload;
    default:
      return state;
  }
};

export const previewUpsellOffer = (state = false, action) => {
  switch (action.type) {
    case constants.SET_PREVIEW_UPSELL_OFFER:
      return action.payload;
    default:
      return state;
  }
};

export default combineReducers({
  environment,
  optedin,
  merchantId,
  offer,
  productOffer,
  sessionId,
  inStock,
  autoshipEligible,
  nextUpcomingOrder,
  showUpsellModal,
  loading,
  auth,
  authUrl,
  locale,
  config,
  previewStandardOffer,
  previewUpsellOffer
});
